import { render } from "./NotificationDialog.html?vue&type=template&id=68779181&ts=true&external"
import script from "./NotificationDialog.vue?vue&type=script&lang=ts"
export * from "./NotificationDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__